import styled from 'styled-components';

export const Svg = styled.svg`
  height: 180px;
  width: 180px;
`;

export const CircleBase = styled.circle`
  stroke: #f4f7f9;
  stroke-width: 8px;
  fill: transparent;
`;

export const CircleProgress = styled.circle`
  stroke-width: 8px;
  fill: transparent;
`;
